"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentQRCodeLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentLoginBg = _interopRequireDefault(require("../assets/student-login-bg.png"));
var _teacherQrcodeHelp = _interopRequireDefault(require("../assets/teacher-qrcode-help.png"));
require("./styles.scss");
var _QRcodeInput = require("./QRcodeInput");
var _state = require("../state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StudentQRCodeLogin = exports.StudentQRCodeLogin = function StudentQRCodeLogin() {
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    getFromPage = _useAuthSigninState.getFromPage;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    hasCameraAccess = _useState2[0],
    setHasCameraAccess = _useState2[1];
  (0, _react.useEffect)(function () {
    if (window.location.hash.includes('student-qrcode')) {
      trackEventsForGuests("Viewed QR Code Input Screen", {
        "mp_login_user_type": "student",
        "From page": getFromPage() || "Direct URL entered"
      }, {
        send_mixpanel: true
      });
    }
    trackAnalyticsEvent('Viewed QR Code Screen', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    }, true);
  }, []);
  var sendInteractedEvent = function sendInteractedEvent() {
    var clickedOn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    trackEventsForGuests("Interacted QR Code Input Screen", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
    trackEventsForGuests(hasCameraAccess ? 'Interacted QR code Input Screen Camera Access' : "Interacted QR code Input Screen No Camera Access", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login",
    "data-sentry-component": "StudentQRCodeLogin",
    "data-sentry-source-file": "QRcodeLogin.tsx"
  }, !showQRPopup ? /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back",
    onClick: function onClick() {
      sendInteractedEvent("Back Button");
      window.location.hash = "#student";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-bg"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _studentLoginBg["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-body qr-code"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Scan the QR code"), /*#__PURE__*/_react["default"].createElement(_QRcodeInput.QRcodeInput, {
    setHasCameraAccess: setHasCameraAccess,
    "data-sentry-element": "QRcodeInput",
    "data-sentry-source-file": "QRcodeLogin.tsx"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Login via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "#student-klasscode?fromPage=QR code scan input screen",
    onClick: function onClick() {
      return sendInteractedEvent("Login via class code");
    }
  }, "Class code")), /*#__PURE__*/_react["default"].createElement("img", {
    src: _teacherQrcodeHelp["default"],
    alt: "Don\u2019t have your QR code? Ask your teacher for help."
  })));
};